import {toAbsoluteUrl} from '../../../helpers'

export function FallbackView() {
  return (
    <div className='splash-screen text-center'>
      <img src={toAbsoluteUrl('/media/logos/logo-dark.svg')} alt='Sexisur' width="250" height="250" />
      <br />
      <span>Cargando ...</span>
    </div>
  )
}
